import { getInterstitialDeps } from "./admob-runtime";

export function interstitialDeps() {
  return getInterstitialDeps();
}
